import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_mail_server_test'

function MailServerTestI18n({ classes }: { classes: ReturnType<typeof styles> }) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  return (
    <div className={classes.content} data-testid="content">
      <p>{formatMessage('intro')}</p>
      <br />
      {formatMessage('note')}
    </div>
  )
}

function MailServerTest(_props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <MailServerTestI18n classes={classes} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      <p>
        To test your mail server/Smart Host configuration, enter an email address for this domain and click <b>Send</b>.
        The system sends a message to the email address you specify. The From address in this email will be{' '}
        <b>Barracuda Networks Email Test</b>.
      </p>
      <br />
      <b>NOTE:</b> If your mail server requires TLS, this test will fail. Because this is only a simple SMTP test, the
      failure indicates the connection is working correctly.
    </div>
  )
}

export default MailServerTest
